function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 365.62 365.62",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005CB9"
    },
    d: "M344.389,181.005v-80.001c0-13.75-11.25-25-25-25H140.96c-13.75,0-25,11.25-25,25v88.626 c0,13.75,11.25,25,25,25h175.141c8.946,7.095,20.252,11.343,32.558,11.343c5.938,0,11.639-1.002,16.961-2.82 C352.738,213.595,344.389,198.278,344.389,181.005z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M304.222,118.443H172.888c-2.485,0-4.5-2.015-4.5-4.5s2.015-4.5,4.5-4.5h131.334 c2.485,0,4.5,2.015,4.5,4.5S306.707,118.443,304.222,118.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M304.222,139.36H156.126c-2.485,0-4.5-2.015-4.5-4.5s2.015-4.5,4.5-4.5h148.096 c2.485,0,4.5,2.015,4.5,4.5S306.707,139.36,304.222,139.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M304.222,160.276h-139.53c-2.485,0-4.5-2.015-4.5-4.5s2.015-4.5,4.5-4.5h139.529 c2.485,0,4.5,2.015,4.5,4.5C308.722,158.261,306.707,160.276,304.222,160.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M304.222,181.193H172.888c-2.485,0-4.5-2.015-4.5-4.5s2.015-4.5,4.5-4.5h131.334 c2.485,0,4.5,2.015,4.5,4.5S306.707,181.193,304.222,181.193z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61B4E4"
    },
    d: "M224.659,139.646H46.23c-13.75,0-25,11.25-25,25v80.001c0,17.273-8.35,32.59-21.23,42.148 c5.322,1.818,11.024,2.82,16.961,2.82c12.306,0,23.611-4.248,32.558-11.343H224.66c13.75,0,25-11.25,25-25v-88.626 C249.659,150.896,238.409,139.646,224.659,139.646z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M192.732,182.084H61.397c-2.485,0-4.5-2.015-4.5-4.5s2.015-4.5,4.5-4.5h131.334 c2.485,0,4.5,2.015,4.5,4.5C197.232,180.069,195.217,182.084,192.732,182.084z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M209.493,203.001H61.397c-2.485,0-4.5-2.015-4.5-4.5s2.015-4.5,4.5-4.5h148.096 c2.485,0,4.5,2.015,4.5,4.5C213.993,200.986,211.979,203.001,209.493,203.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M200.927,223.917H61.397c-2.485,0-4.5-2.015-4.5-4.5s2.015-4.5,4.5-4.5h139.529 c2.485,0,4.5,2.015,4.5,4.5C205.427,221.902,203.412,223.917,200.927,223.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M192.732,244.834H61.397c-2.485,0-4.5-2.015-4.5-4.5s2.015-4.5,4.5-4.5h131.334 c2.485,0,4.5,2.015,4.5,4.5C197.232,242.819,195.217,244.834,192.732,244.834z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryIcon);
export default __webpack_public_path__ + "static/media/QueryIcon.071049c251c0fd5fbdb40b2c552ca9ba.svg";
export { ForwardRef as ReactComponent };